/**
 * @param {number} joinTime
 * @param {number} now
 * @param {number} weekHelp
 * @returns {number}
 */
export function calcMemberActivityRating(joinTime, now, weekHelp) {
  const membershipDurationDays = calcMemberMembershipDurationDays(joinTime, now)
  return membershipDurationDays * weekHelp;
}

/**
 * @param {number} joinTime
 * @param {number} now
 * @returns {number}
 */
export function calcMemberMembershipDurationDays(joinTime, now) {
  const membershipDurationSec = now - joinTime;

  const dayDurationSec = 24 * 60 * 60;
  const membershipDurationDays = Math.floor(membershipDurationSec / dayDurationSec);

  return membershipDurationDays;
}